import React from 'react';
import './AwardPage.css'; // Importing styles for the Awards page

// Importing necessary components and sections
import { PageTitle } from '../../../components';
import { Awards } from '../../../sections';

const AwardPage = () => { 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Awards'} page={'Awards'} /> 

      {/* Awards Section */}
      <Awards />

    </>
  );
}

export default AwardPage;